import { useEffect, useState } from 'react';
import { ReactSortable } from 'react-sortablejs';
import Button from '../ui/Button.jsx';
import { Card } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

// const LOCKED_INDICES = [0, 10, 11];
// const isLockedIndex = (i) => LOCKED_INDICES.includes(i);


const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

const HackPassword = ({ heading, button, variants, feedback, fn }) => {
    const numbers = [1, 2, 4, 5, 6, 8, 9, 10, 11];
    // const _variantKey = getRandomInt(0, variants.length - 1);

    //
    // console.log(variantKey);
    const [variantKey, setVariantKey] = useState(getRandomInt(0, variants.length - 1));
    const [variantSelected, setVariantSelected] = useState([]);
    const [leftNumbers, setLeftNumbers] = useState([]);
    const [rightNumbers, setRightNumbers] = useState(numbers.map((n) => ({ id: `num-${n}`, value: n })));

    useEffect(() => {
        setVariantSelected(variants[variantKey]);
        setLeftNumbers(variants[variantKey]);
        setRightNumbers(numbers.map((n) => ({ id: `num-${n}`, value: n })));
    }, [variantKey]);

    const isLockedIndex = (i) => variantSelected[i] !== null;
    const getLockedValue = (i) => variantSelected[i] ?? null;

    const handleDragStartRight = (e, val) => {
        e.dataTransfer.setData('text/plain', String(val));
    };

    const handleDragStartLeft = (e, index, val) => {
        const payload = JSON.stringify({ type: 'left-internal', fromIndex: index, value: val });
        e.dataTransfer.setData('application/json', payload);
    };

    const handleDrop = (e, targetIndex) => {
        e.preventDefault();

        if (isLockedIndex(targetIndex)) return;

        const jsonPayload = e.dataTransfer.getData('application/json');
        if (jsonPayload) {
            try {
                const payload = JSON.parse(jsonPayload);
                if (payload?.type === 'left-internal') {
                    const { fromIndex, value } = payload;
                    if (fromIndex === targetIndex) return;
                    if (isLockedIndex(fromIndex) || isLockedIndex(targetIndex)) return;

                    setLeftNumbers((prev) => {
                        const next = [...prev];
                        const draggedValue = value;
                        const targetValue = prev[targetIndex];

                        if (targetValue === null) {
                            next[targetIndex] = draggedValue;
                            next[fromIndex] = null;
                        } else {
                            next[targetIndex] = draggedValue;
                            next[fromIndex] = targetValue;
                        }
                        return next;
                    });
                    return;
                }
            } catch (err) {
                console.error('Error parsing JSON payload:', err);
            }
        }

        const draggedNumber = parseInt(e.dataTransfer.getData('text/plain'), 10);
        if (Number.isNaN(draggedNumber)) return;

        if (isLockedIndex(targetIndex)) return;

        setLeftNumbers((prev) => {
            if (prev[targetIndex] !== null) {
                return prev;
            }

            const next = [...prev];
            next[targetIndex] = draggedNumber;

            setRightNumbers((old) => old.filter((it) => it.value !== draggedNumber));

            return next;
        });
    };

    useEffect(() => {
        if (!leftNumbers.includes(null)) {
            fn.handleAction('set:form', {
                variant: variantKey,
                data: leftNumbers,
            });
            // console.log({
            //     variant: variantKey,
            //     data: leftNumbers,
            // });
        }
    }, [leftNumbers]);

    const handleDragOver = (e) => e.preventDefault();

    const handleReset = () => {
        fn.handleAction('set:form', {});
        fn.handleAction('set:feedback', null);
        setVariantKey(getRandomInt(0, variants.length - 1));
    };

    // console.log(leftNumbers);
    return (
        <div className="component-hack">
            <div className="row">
                <HeadingOne className="col" heading={heading} />
            </div>
            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <div className="p-10">
                            <div className="flex gap-8">
                                <div className={'left-wrapper w-7/12 ' + feedback}>
                                    {leftNumbers.map((num, i) => {
                                        let numberToShow = num;
                                        if (getLockedValue(i)) {
                                            numberToShow = getLockedValue(i);
                                        }
                                        // if (i === 0 && !num) numberToShow = 3;
                                        // if (i === 10 && !num) numberToShow = 7;
                                        // if (i === 11 && !num) numberToShow = 12;

                                        const locked = isLockedIndex(i);
                                        const isDraggable = numberToShow !== null && !locked;

                                        return (
                                            <div
                                                key={i}
                                                className={`left-cell ${locked ? 'locked' : ''}`}
                                                onDrop={(e) => handleDrop(e, i)}
                                                onDragOver={handleDragOver}
                                            >
                                                <div
                                                    className={`left-circle ${numberToShow ? 'filled' : ''}`}
                                                    draggable={isDraggable}
                                                    onDragStart={(e) => {
                                                        if (isDraggable) handleDragStartLeft(e, i, numberToShow);
                                                    }}
                                                >
                                                    <svg viewBox="0 0 125 125" className="circle-svg">
                                                        <circle cx="62.5" cy="62.5" r="60" className="circle-border" />
                                                        {numberToShow && (
                                                            <text
                                                                x="50%"
                                                                y="55%"
                                                                textAnchor="middle"
                                                                dominantBaseline="middle"
                                                                className="circle-text"
                                                            >
                                                                {numberToShow}
                                                            </text>
                                                        )}
                                                    </svg>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="flex w-5/12 flex-wrap items-center justify-center gap-4">
                                    {feedback ? (
                                        feedback === 'success' ? (
                                            <div className="font-bold">Skvělé, podařilo se ti prolomit heslo.</div>
                                        ) : (
                                            <div className="font-bold">
                                                Chybně zadané heslo.
                                                <br />
                                                Zkus to ještě jednou.
                                            </div>
                                        )
                                    ) : (
                                        <ReactSortable
                                            tag="div"
                                            list={rightNumbers}
                                            setList={setRightNumbers}
                                            group={{ name: 'numbers-for-hack', pull: true, put: false }}
                                            sort={true}
                                            animation={150}
                                            style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(3, 110px)',
                                                gridGap: '40px',
                                            }}
                                            ghostClass="drag-ghost"
                                        >
                                            {rightNumbers.map((item) => (
                                                <div
                                                    key={item.id}
                                                    className="right-circle cursor-grab"
                                                    draggable
                                                    onDragStart={(e) => handleDragStartRight(e, item.value)}
                                                >
                                                    {item.value}
                                                </div>
                                            ))}
                                        </ReactSortable>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className="mt-5 flex justify-end">
                        {feedback ? (
                            feedback === 'success' ? (
                                <Button {...button} onClick={() => fn.handleAction('step:continue')}>
                                    Pokračovat
                                </Button>
                            ) : (
                                <Button {...button} onClick={() => handleReset()}>
                                    Zkusit znovu
                                </Button>
                            )
                        ) : (
                            !leftNumbers.includes(null) && <Button {...button} onClick={() => fn.handleAction(button.action)} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HackPassword;
